import ZoneManagerTCList from "../../features/zoneManager/ZoneManagerTCList"

const ZoneManagerTCListPage = () => {
  return <ZoneManagerTCList/>
}

export default ZoneManagerTCListPage